import { useQuery } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { productKeys } from './keys';

import type { TypeCategoryType, TypeGetCategoriesTypesResponse } from '~/types/product.types';

/**
 * [상품관리] 카테고리 타입별 조회 API
 * @param type 카테고리 타입 (MAIN, MIDDLE, THIRD)
 */
export const fetchCategoriesTypesType = async (type: TypeCategoryType) => {
  const endpoint = '/api-lip/v1/categories/types';
  const { data } = await axiosInstance.get<TypeGetCategoriesTypesResponse>(`${endpoint}/${type}`);
  return data.data;
};

type UseGetCategoriesTypesTypeQueryOptions = {
  type: TypeCategoryType;
  enabled?: boolean;
  showGlobalDimOverlay?: boolean;
  showGlobalErrorToast?: boolean;
};

/**
 * [상품관리] 카테고리 타입별 조회 Query Hook
 * @description MAIN 카테고리일 경우 또는 카테고리 타입별로 조회가 필요할 경우 사용한다.
 */
export const useGetCategoriesTypesTypeQuery = ({
  type,
  enabled = true,
  showGlobalDimOverlay = true,
  showGlobalErrorToast = true,
}: UseGetCategoriesTypesTypeQueryOptions) => {
  return useQuery({
    queryKey: productKeys.categoriesTypes(type),
    queryFn: () => fetchCategoriesTypesType(type),
    staleTime: 1000 * 60 * 30, // 30분
    enabled,
    meta: { showGlobalDimOverlay, showGlobalErrorToast },
  });
};
